import { Stack, Typography, styled, useMediaQuery } from '@mui/material';
import { useLocalization } from '@/data/Localization';
import { titleSX } from '@/components/blocks/GroupPageLink/styles';
import { Linkable } from '@/components/blocks/Linkable';

const Img = styled('img')({
	width: 'auto',
	minHeight: '36px',
});

export const DownloadOurApp = () => {
	const footerNLS = useLocalization('Footer');
	const isMobile = useMediaQuery(`(max-width:1280px)`);

	return (
		<Stack
			sx={{
				display: { xs: 'grid' },
				placeItems: { xs: 'center', md: 'center' },
				width: isMobile ? '100%' : 'fit-content',
			}}
			spacing={1}
		>
			<Typography sx={titleSX}>{footerNLS.DownloadOurApp.t()}</Typography>
			<Stack gap={1} direction="row">
				<Linkable href="https://apps.apple.com/mx/app/dp/id1322600874" target="_blank">
					<Img
						src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/images/diseno/icons/app_store.webp"
						alt="App Store"
						height="40px!important"
					/>
				</Linkable>
				<Linkable
					href="https://play.google.com/store/apps/details?id=mx.grupodp.dp"
					target="_blank"
				>
					<Img
						src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/images/diseno/icons/google_play.webp"
						alt="Google Play"
						height="40px!important"
					/>
				</Linkable>
			</Stack>
		</Stack>
	);
};
